import { IsNotEmpty, IsString } from 'class-validator';

export class TimezoneDto {
  @IsString()
  @IsNotEmpty()
  value: string;

  @IsString()
  @IsNotEmpty()
  label: string;
}
